module.exports = __webpack_public_path__ + "media/images/mammaluisa-logo-c77324db316100f93c4ffda80545a609.png";